module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/umd-33.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/umd.md
// module id = 775
// module chunks = 391